import classes from "./AboutBanner.module.css";
import images, { imagesAlts } from "../../../resources/images";
import React from "react";
import * as links from "../../../utils/links";
import { logEvents } from "../../../eventsManager";
import { t } from "i18next";
import { PrimaryButton } from "../../Common";

const AboutBanner = ({ isGreen }) => {
  const onBannerClick = () => {
    links.linkToExternalPage(links.URLS.vegan_active_homepage);
    logEvents("ad_click", {
      banner_name: "vegan_active",
      banner_location: isGreen ? "footer" : "home",
    });
  };

  return (
    <div className={classes.mainContainer} onClick={onBannerClick}>
      <img className={classes.icon} src={images.bannerAbout} alt={imagesAlts.bannerAbout} />
      <div className={classes.contentContainer}>
        <h4 className={classes.title}>{t("about_banner_title")}</h4>

        <PrimaryButton title={t("about_banner_subtitle")} isSlim={true} />
        {/* <h4 className={classes.subtitle}>{t("business_banner_subtitle")}</h4> */}
      </div>
    </div>
  );
};

export default AboutBanner;
